import { render, staticRenderFns } from "./OperationTeacher.vue?vue&type=template&id=24654258&scoped=true&"
import script from "./OperationTeacher.vue?vue&type=script&lang=js&"
export * from "./OperationTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24654258",
  null
  
)

export default component.exports